const config = require("./config.json");

export const APP_ENV = process.env.REACT_APP_ENV;
export const baseUri = process.env.REACT_APP_API_BASE_URL;
export const client_url = process.env.REACT_APP_CLIENT_URL;
export const s3baseUri = process.env.REACT_APP_PIC_BASE_URL;
export const xshKey = process.env.REACT_APP_SSH_KEY;
export const web_url = process.env.REACT_APP_WEB_URL;
export const project_mode = process.env.REACT_APP_PROJECT_MODE;
